import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/profile")({
  beforeLoad: () => {
    // Redirect profile page to settings page for consolidation
    throw redirect({
      to: "/settings",
      replace: true,
    })
  },
})
